import { FormUserInvitation } from '../types';

export function isEmptyInvitation(invitation: FormUserInvitation) {
  return !invitation.FirstName && !invitation.LastName && !invitation.Email;
}
